{
  "common_action_cancel": "Cancel",
  "common_action_submit": "Submit",
  "common_action_upload": "Upload",
  "common_tab_attach": "Upload from device",
  "common_tab_link": "Add by link",
  "common_link": "Link",
  "common_sizes": "Size, px",
  "iframe_link_help": "URL of the resource displayed in the frame.",
  "iframe_sizes_help": "Width and height of the frame in pixels.",
  "image_name": "Title",
  "image_link_href": "Image link",
  "image_link_href_help": "Adress the image link leads to.",
  "image_alt": "Alt text",
  "image_alt_help": "Alt text is displayed if the image cannot be loaded.",
  "image_upload_help": "JPEG, GIF or PNG image no larger than 1 MB.",
  "image_upload_failed": "Image failed to upload",
  "image_size_width": "Width",
  "image_size_height": "Height",
  "link_url_help": "Address the link leads to.",
  "link_text": "Link text",
  "link_text_help": "Text displayed as a link.",
  "link_open_help": "Open the link in a new tab",
  "file_link_help": "Link to download the file",
  "file_name": "File name",
  "file_upload_help": "Upload multiple files at once from your device.",
  "file_upload_failed": "Failed to upload files",
  "anchor_href": "Anchor identifier",
  "anchor_href_help": "Consists of numbers, symbols and Latin letters. Anchors are used for page navigation.",
  "anchor_title": "Hint",
  "anchor_title_help": "The text of the popup hint when hovering over the anchor node",
  "form_id": "Link or Form ID"
}
